import NextImage from 'next/image'
import NextLink from 'next/link'

import { Text } from '@wartek-id/text'

import { formatDate } from 'utils/datetime'
import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'

type TCeritaPraktikListItemProps = React.HTMLAttributes<HTMLAnchorElement> & {
  index: number
  id: string
  title: string
  thumbnail: string
  publishedAt: string
}
const ListItem = ({
  index,
  id,
  title,
  thumbnail,
  publishedAt,
  ...props
}: TCeritaPraktikListItemProps) => {
  const link = `/cerita-praktik/${id}`

  const { SETrackClickCeritaPraktikItem } = useSETrackEvent()

  const onClickItem = () => {
    SETrackClickCeritaPraktikItem({
      ceritaPraktikLocation: index + 1,
      ceritaPraktikId: id,
    })
  }

  return (
    <NextLink href={link} passHref>
      <a {...props} onClick={onClickItem}>
        <div className="mb-3">
          {Boolean(thumbnail) && (
            <div className="h-[200px] relative !border !border-b-0 !border-subdued rounded-t-[4px]">
              <NextImage
                className="w-full h-full object-cover rounded-t-[4px]"
                width="600px"
                height="400px"
                layout="fill"
                src={thumbnail}
                alt={title}
              />
            </div>
          )}
          <div className="p-3 border border-t-0 border-subdued bg-white rounded-b-[4px]">
            <div className="mb-2">
              <Text variant="action" className="line-clamp-3">
                {title}
              </Text>
            </div>
            <Text variant="helper">{formatDate(publishedAt)}</Text>
          </div>
        </div>
      </a>
    </NextLink>
  )
}

export default ListItem
